import type { Capability } from '@taler/api-client'

/** The one place this feature's view gate is written; the page and the nav both call it.
 * A role defined entirely by numbers (AGGREGATES_VIEW granted, ACCOUNT_VIEW_BALANCES not -
 * the aggregates-viewer shape) loses the screen rather than being offered a chart with no
 * figures on it; a role with neither capability, like a contributor, still sees it with the
 * balance and currency columns collapsed. */
export function canViewAccounts(can: (capability: Capability) => boolean): boolean {
  if (!can('ACCOUNT_VIEW_NAMES')) return false
  return can('ACCOUNT_VIEW_BALANCES') || !can('AGGREGATES_VIEW')
}

export function canViewAccountBalances(can: (capability: Capability) => boolean): boolean {
  return can('ACCOUNT_VIEW_BALANCES')
}

export function canCreateAccount(can: (capability: Capability) => boolean): boolean {
  return can('ACCOUNT_CREATE')
}

/** Rename/recolour/icon (accounts_update) is gated on ACCOUNT_CREATE - contract/conventions.md §0. */
export function canEditAccount(can: (capability: Capability) => boolean): boolean {
  return can('ACCOUNT_CREATE')
}

/** Hide/unhide are gated on ACCOUNT_CREATE too - contract/conventions.md §0: "the same audience
 * that creates accounts, since neither rebuckets history". */
export function canHideAccount(can: (capability: Capability) => boolean): boolean {
  return can('ACCOUNT_CREATE')
}

export function canArchiveAccount(can: (capability: Capability) => boolean): boolean {
  return can('ACCOUNT_ARCHIVE')
}
